export default function() {
  const setAnnouncementBar = code => {
    // get custom element
    const customElements = document.querySelectorAll(`.js-announcement[data-country="${code}"]`);
    if (customElements.length) {
      customElements.forEach(customElement => {
        customElement.classList.remove('hide');
      });
    } else {
      const defaultElements = document.querySelectorAll(`.js-announcement[data-country="default"]`);
      defaultElements.forEach(defaultElement => {
        if (defaultElement) {
          defaultElement.classList.remove('hide');
        }
      });
    }
  };

  const langCode = localStorage.getItem('geoCountry');
  if (langCode && langCode !== '') {
    setAnnouncementBar(langCode);
  } else {
    // fetch from geoip service
    fetch('https://geoip.apps.esign.eu/api/v1/location', {
      method: 'GET',
      headers: {
        Authorization:
          'Bearer fxFBlZviculmHxZcPAHyBthi0suBUF5fBwiZvIqPINq7kPx7DD8l2kCRusR3fpfYJ4qcd3WzJHdfYi6Z',
        Accept: 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        // storage data
        const code = data.iso_code.toLowerCase();
        localStorage.setItem('geoCountry', code);

        setAnnouncementBar(code);
      })
      .catch(error => {
        console.log(error);
      });
  }
}
